// Digital Charged Reducer
const digitalChargedDefaultState = {
    dateNaissance: null,
    prenom: '',
    nom: '',
    address: '',
    zipCode: '',
    city: '',
    digitalCharged: '',
    facebook : '',
    twitter : '',
    codeCountry : '',
    idBeneficiaire:'',
    email:'',
    telephone:'',
    profils:'',
    addDigitalCharged : '0'
};

export default (state = digitalChargedDefaultState, action) => {
    switch (action.type) {
        case 'SET_DIGITAL_CHARGED':
            return {
                ...state,
                dateNaissance: action.data.date,
                prenom: action.data.firstName,
                nom: action.data.name,
                address: action.data.address,
                zipCode: action.data.zipCode,
                city: action.data.city,
                email:action.data.email,
                telephone:action.data.telephone,
                digitalCharged: action.data.digitalCharged,
                facebook :action.data.facebook,
                twitter : action.data.twitter,
                codeCountry : action.data.codeCountry,
                idBeneficiaire:action.data.idBeneficiaire,
                profils:action.data.profils,
                mission:action.data.mission,
                addDigitalCharged : action.data.addDigitalCharged == '1' ? '1' : '0',
                role:'digitalCharged'
            };
            case 'GET_DIGITAL_CHARGED':
            return {
                ...state,
                dateNaissance: action.data.dateNaissance,
                prenom: action.data.prenom,
                nom: action.data.nom,
                address: action.data.address,
                zipCode: action.data.codePostal,
                city: action.data.ville,
                email:action.data.email,
                telephone:action.data.telephone,
                digitalCharged: action.data.digitalCharged,
                facebook :action.data.facebook,
                twitter : action.data.twitter,
                codeCountry : action.data.codeCountry,
                idBeneficiaire:action.data.idBeneficiaire,
                profils:action.data.profils,
                mission:action.data.mission,
                addDigitalCharged : action.data.addDigitalCharged == '1' ? '1' : '0',
                role:'digitalCharged'
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/digitalCharged.js